import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { cn } from '../../utils/cn';

export const Alert = ({ variant = 'info', title, message, className = '' }) => {
  const variants = {
    info: 'bg-blue-50/80 text-blue-800 border-blue-100',
    success: 'bg-emerald-50/80 text-emerald-800 border-emerald-100',
    error: 'bg-red-50/80 text-red-800 border-red-100',
    warning: 'bg-amber-50/80 text-amber-800 border-amber-100'
  };

  const icons = {
    info: FiIcons.FiInfo,
    success: FiIcons.FiCheckCircle,
    error: FiIcons.FiAlertCircle,
    warning: FiIcons.FiAlertTriangle
  };

  return (
    <div className={cn("rounded-xl border p-4", variants[variant], className)}>
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <SafeIcon icon={icons[variant]} className="h-5 w-5 mt-0.5" />
        </div>
        <div className="ml-3">
          {title && <h3 className="text-sm font-semibold tracking-tight">{title}</h3>}
          <div className={cn("text-sm leading-relaxed", title && "mt-1")}>
            {message}
          </div>
        </div>
      </div>
    </div>
  );
};